'use client';

import { Badge, MENU_ROW_CLASS } from '../../lib/header-constants';
import { cn } from '@/shared/utils/cn';
import { useNavbarContext } from './context';
import type { NavDropdownItem } from '../../types/navigation';

interface HeaderSimpleDropdownListProps {
  items: NavDropdownItem[];
}

const HeaderSimpleDropdownList = ({ items }: HeaderSimpleDropdownListProps) => {
  const { onNavClick } = useNavbarContext();

  return (
    <ul className="space-y-0.5">
      {items.map((item) => (
        <li key={item.label}>
          <a
            className={cn('flex items-center justify-between gap-3', MENU_ROW_CLASS)}
            href={item.href}
            onClick={() => onNavClick?.({ href: item.href, label: item.label, url: item.href })}
          >
            <span>{item.label}</span>
            {item.badge ? <Badge color={item.badgeColor!} label={item.badge} /> : null}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default HeaderSimpleDropdownList;
